const initialState = null;
  
const getEventId  = (state = initialState, action) => {
    switch (action.type) {
        case 'EVENTID':
        return state=action.value
        default:
          return state
      }
  };

  export default getEventId;